import React from "react";
import PropTypes from "prop-types";

function ListGroupHeader(props) {
  const { children } = props;

  return <p className="text-base font-bold">{children}</p>;
}

ListGroupHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default ListGroupHeader;
